module.exports = __webpack_public_path__ + "static/gallery_peak_3-cebe8509691646d81ce069dcfe124ccb.jpg";